import { useState } from 'react'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'

import { Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions, Label } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon, ChevronDownIcon, ClockIcon } from '@heroicons/react/20/solid'

import {FieldHolder} from "@/components/holders/FieldHolder";
import { PPCTimeField } from "@/components/datetime/PPCTimeField";
import CalenderHelperClass from '@/helpers/CalenderHelper'

export function SelectInterval({...props}) {
const people = [
  { id: 1, name: 'Hele dag beschikbaar' },
  { id: 2, name: 'Hele dag afwijzig' },
  { id: 3, name: 'Afwezigheid instellen' },
]    
  const [selected, setSelected] = useState(people[1])
  const [query, setQuery] = useState('')

  const filteredPeople =
    query === ''
      ? people
      : people.filter((person) => {
          return person.name.toLowerCase().includes(query.toLowerCase())
        })

  return (
  <div className="mx-auto w-auto">
      <Combobox value={selected} onChange={(value) => setSelected(value)} onClose={() => setQuery('')} >
        <div className="relative w-fit">
            <div className="border rounded" >
          <ComboboxInput
            className={(
              'w-auto rounded-lg border-none bg-white/5 py-1.5 pr-8 pl-3 text-sm/6 text-black focus:outline-none focus:outline-none data-[focus]:outline-2 data-[focus]:-outline-offset-2 data-[focus]:outline-black/25')}
              //'focus:outline-none data-[focus]:outline-2 data-[focus]:-outline-offset-2 data-[focus]:outline-white/25'
            displayValue={(person) => person['name']}
            onChange={(event) => setQuery(event.target.value)}
          />
          <ComboboxButton className="group inset-y-0 right-0 px-2.5">
            <ChevronDownIcon className="size-4 fill-black/60 group-data-[hover]:fill-black" />
          </ComboboxButton>
          </div>
        </div>

        <ComboboxOptions
          //anchor="bottom"
          className={'absolute z-10 w-[var(--input-width)] border border-white/5  p-1 mt-2 empty:invisible bg-white'}
          //'transition duration-100 ease-in data-[leave]:data-[closed]:opacity-0'
        >
          {filteredPeople.map((person) => (
            <ComboboxOption
              key={person.id}
              value={person}
              className="group flex cursor-default items-left gap-2 rounded-lg  select-none data-[focus]:bg-white/10 bg-white"
            >
              <CheckIcon className="invisible size-4 fill-white group-data-[selected]:visible" />
              <div className="text-sm/6 text-black">{person.name}</div>
            </ComboboxOption>
          ))}
        </ComboboxOptions>
      </Combobox>
      
      
<div className="grid grid-cols-12 items-start gap-2 pb-2">
        <div className="flex col-span-1" >
        <ClockIcon className="size-6" />
        <label htmlFor="username" className="block text-sm/6 font-medium text-gray-900 col-span-1">Vanaf</label>
        </div>
    <FieldHolder colspan="2" smcolspan="2"  id="location" error={null}>
      <PPCTimeField name="extra.appointment.traveltime"  hourCycle={24} />
    </FieldHolder>
</div>

<div className="grid grid-cols-12 items-start gap-2 pb-2">
        <div className="flex col-span-1" >
        <ClockIcon className="size-6" />
        <label htmlFor="username" className="block text-sm/6 font-medium text-gray-900 col-span-1">Tot</label>
        </div>
    <FieldHolder colspan="2" smcolspan="2"  id="location" error={null}>
      <PPCTimeField name="extra.appointment.traveltime"  hourCycle={24} />
    </FieldHolder>
</div>

<div className="grid grid-cols-12 items-start gap-2 pb-2">
        <div className="flex col-span-1" >
        <ClockIcon className="size-6" />
        <label htmlFor="username" className="block text-sm/6 font-medium text-gray-900 col-span-1">Elke</label>
        </div>
    <FieldHolder colspan="2" smcolspan="2"  id="location" error={null}>
      <input className="w-12" defaultValue="1"/>
      <span>Weken - </span>
      <label htmlFor="username" className="text-sm/6 font-medium text-gray-900">start in week</label>
        <input className="w-12" defaultValue={CalenderHelperClass.currentWeek()}/>
    </FieldHolder>
</div>
 
      
      
    </div>
     )
}